module.exports = __webpack_public_path__ + "d821e7fdd86a54c4e9a6041265654f65.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pineapple.png
// module id = 2579
// module chunks = 0